
$(document).ready(function () {

  // // 🌀 Initialize thumbs Swiper
  // var thumbsSwiper = new Swiper(".thumb-swiper", {
  //   direction: "vertical",
  //   spaceBetween: 10,
  //   slidesPerView: 6,
  //   freeMode: true,
  //   watchSlidesProgress: true,
  //   navigation: {
  //     nextEl: ".thumbs-next",
  //     prevEl: ".thumbs-prev",
  //   },
  //   breakpoints: {
  //     0: {
  //       direction: "horizontal",
  //       slidesPerView: 4,
  //     },
  //     721: {
  //       direction: "vertical",
  //       slidesPerView: 6,
  //     },
  //   },
  // });

  // // 🌟 Initialize main Swiper linked to thumbs
  // var mainSwiper = new Swiper(".main-swiper", {
  //   spaceBetween: 10,
  //   slidesPerView: 1,
  //   thumbs: {
  //     swiper: thumbsSwiper,
  //   },
  // });

  // 🧭 Initialize Magnific Popup after short delay (helps iPhone load timing)
  setTimeout(function () {
    if ($.fn.magnificPopup) {
      $(".image-popup-vertical-fit").magnificPopup({
        type: "image",
        mainClass: "mfp-with-zoom",
        gallery: { enabled: true },
        zoom: {
          enabled: true,
          duration: 300,
          easing: "ease-in-out",
          opener: function (openerElement) {
            return openerElement.is("img")
              ? openerElement
              : openerElement.find("img");
          },
        },
      });
    }
  }, 400);

});

